import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import PageHeader from "../Comman/PageHeader";
import CandidatePay from "./CandidatePay";
import SubcontractorDetails from "./SubcontractorDetails";
import http from "../../Services/httpService";
import auth from "../../Services/authService";
import config from "../../config.json";
import AddNewTimeLog from "./AddNewTimeLog";
import UploadInvoice from "./UploadInvoice";
import AddEditNotes from "./AddEditNotes";
import {
  formatTotalHours,
  getAllMonths, getAllYears, getFieldData, getFormatedNumber,
  getMonthLastDay, getMonthName, getTotalDays, getTotalHours
} from "../../Services/appService";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllRates, getTimeLogDuration, getTimeLogs, loadAllRates, loadTimeLogDuration, loadTimeLogs } from "../../app/store/timeLog";
import { getTimeLogDeleteReqStatus, getTimeLogInvoice, loadTimeLogInvoice, timeLogInvDocDeleteReq } from "../../app/store/timeLogInvoice";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import useDocDownload from "../../app/hooks/useDocDownload";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";

export default function CandidateInvoice() {

  const route = [
    { name: "Contract Management", url: "" },
    { name: "Invoices and Payments", url: "/PartnerInvoices" },
  ];


  const usrType = localStorage.getItem("userType");

  const [timeLogs, setTimeLogs] = useState([]);
  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [invType, setInvType] = useState("subcontractor");
  const [rate, setRate] = useState(0);
  const [performerData, setPerformerData] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [entType, setEntType] = useState("");
  const [w9Type, setW9Type] = useState("");
  const [costBefenifit, setCostBefenifit] = useState("");
  const [candidateObj, setCandidateObj] = useState(null);
  const [notesType, setNotesType] = useState(usrType === "recruiter" ? "TimeLogRecruiter" : "TimeLog");
  const [selectedItem, setSelectedItem] = useState(null);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [timeLogObj, setTimeLogObj] = useState(null);
  const [filterYear, setFilterYear] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [showHide, setShowHide] = useState(false);
  const [payShowHide, setPayShowHide] = useState(false);
  const [showHideTimeLog, setShowHideTimeLog] = useState(false);
  const [invShowHide, setInvShowHide] = useState(false);
  const [allRates, setAllRates] = useState([]);

  const [handleDownloadFile] = useDocDownload();

  const years = getAllYears();
  const months = getAllMonths();

  const timeLogsSelector = useSelector(getTimeLogs);
  const timeLogInvoiceSelector = useSelector(getTimeLogInvoice);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);
  const allRatesSelector = useSelector(getAllRates);
  const timeLogDeleteReqStatusSelector = useSelector(getTimeLogDeleteReqStatus);


  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Candidate Invoice Detail"));
    dispatch(setCurrentRoute(route))
  }, [])

  useEffect(() => {
    const state = location.state;
    if (state) {
      setSelectedItem(state);
      let rate = 0;
      if (usrType === "recruiter" && state.rates) {
        setNotesType("TimeLogRecruiter");
        rate = state.rates.recruiterRate;
      }
      if (usrType === "subcontractor" && state.rates) {
        rate = state.rates.subcontractorRate;
        setNotesType("TimeLog");
      }
      setRate(rate);
      setInvType(usrType);

      setPerformerData(state.performerData);
      dispatch(loadTimeLogs(state.performerid));
      dispatch(loadTimeLogInvoice(state.performerid));
      dispatch(loadTimeLogDuration(state.performerid));
      dispatch(loadAllRates(state.performerid));
      setCandidateObj(state);

      const entType = getFieldData(state.performerData, "candidateonboardingform", "CandidateEntity");
      setEntType(entType);
      const w9Type = getFieldData(state.performerData, "candidateonboardingform", "w9_Type");
      setW9Type(w9Type);
      const costBefenifit = getFieldData(state.performerData, "candidateonboardingform", "Cost_of_Benefit");
      setCostBefenifit(costBefenifit);
    }
  }, []);

  useEffect(() => {
    setTimeLogs(timeLogsSelector);
  }, [timeLogsSelector])

  useEffect(() => {
    if (timeLogInvoiceSelector.length > 0) {
      const filterInvoices = timeLogInvoiceSelector.filter(x => x.invoiceType === invType);
      setTimeLogInvoices(filterInvoices);
    }
    else {
      setTimeLogInvoices([]);
    }

    if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate() + 1); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }
  }, [timeLogInvoiceSelector]);

  useEffect(() => {
    let filterTimeLogs = [...timeLogsSelector];
    if (filterYear > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.year === parseInt(filterYear));

    if (filterMonth > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.month === parseInt(filterMonth));

    setTimeLogs(filterTimeLogs);

  }, [filterMonth, filterYear])

  useEffect(() => {
    setAllRates(allRatesSelector);
    console.log("allRatesSelector", allRatesSelector);
  }, [allRatesSelector])

  const getApplicableRateDetails = (item) => {
    const itemYear = parseInt(item?.year, 10);
    const itemMonth = parseInt(item?.month, 10);
    const rateField = usrType === "recruiter" ? "recruiterRate" : "subcontractorRate";
    const dateField = usrType === "recruiter" ? "recruiterEffectiveDate" : "subcontractorEffectiveDate";

    const matchedRate = Array.isArray(allRates)
      ? allRates.reduce((best, rate, index) => {
        if (!itemYear || !itemMonth) return best;

        const effMs = new Date(rate?.[dateField]).getTime();
        if (Number.isNaN(effMs)) return best;

        const effDt = new Date(effMs);
        const effYear = effDt.getFullYear();
        const effMonth = effDt.getMonth() + 1;
        const isApplicable =
          effYear < itemYear ||
          (effYear === itemYear && effMonth <= itemMonth);

        if (!isApplicable) return best;
        if (!best) return { rate, index, effMs };

        if (effMs > best.effMs) return { rate, index, effMs };
        if (effMs < best.effMs) return best;

        const addedMs = new Date(rate?.addedDateTime).getTime();
        const bestAddedMs = new Date(best.rate?.addedDateTime).getTime();
        const safeAddedMs = Number.isNaN(addedMs) ? -Infinity : addedMs;
        const safeBestAddedMs = Number.isNaN(bestAddedMs) ? -Infinity : bestAddedMs;

        if (safeAddedMs > safeBestAddedMs) return { rate, index, effMs };
        if (safeAddedMs < safeBestAddedMs) return best;

        const idNum = Number(rate?.id);
        const bestIdNum = Number(best.rate?.id);
        const safeIdNum = Number.isFinite(idNum) ? idNum : -Infinity;
        const safeBestIdNum = Number.isFinite(bestIdNum) ? bestIdNum : -Infinity;

        if (safeIdNum > safeBestIdNum) return { rate, index, effMs };
        if (safeIdNum < safeBestIdNum) return best;

        return index > best.index ? { rate, index, effMs } : best;
      }, null)?.rate
      : null;

    const fallbackRate = parseFloat(rate || 0);
    const rateValue =
      matchedRate?.[rateField] !== null &&
        matchedRate?.[rateField] !== undefined &&
        matchedRate?.[rateField] !== ""
        ? parseFloat(matchedRate[rateField])
        : fallbackRate;

    const effectiveDate = matchedRate?.[dateField] || rate;

    return {
      rate: rateValue,
      effectiveDate,
    };
  };

  const getInvoiceAmount = (item) => {
    const totHrs = getTotalHours(item?.workingHrs || 0);
    const { rate: applicableRate } = getApplicableRateDetails(item);
    let invAmt = totHrs * applicableRate;

    // If not W2, return straight amount
    if (entType !== "W2 Basis") {
      return parseFloat(invAmt || 0).toFixed(2);
    }

    // W2 → add tax
    const taxRate = (getFieldData(performerData, "candidateonboardingform", "Tax") || 0) / 100;
    invAmt = invAmt + invAmt * taxRate;

    return parseFloat(invAmt || 0).toFixed(2);
  };

  const getFinalAmout = (obj) => {
    let fAmt = parseFloat(getInvoiceAmount(obj) || 0);

    const invItems = timeLogInvoices.filter(
      (x) => x.timeLogId === obj.id
    );

    if (invItems.length === 0) {
      return fAmt.toFixed(2);
    }

    const item = invItems[0];

    const adjMinus = parseFloat(item?.adjustmentMinues || 0);
    const adjPlus = parseFloat(item?.adjustmentPlus || 0);
    const adp = parseFloat(item?.adpDeduction || 0);

    // Apply adjustments
    fAmt = fAmt - adjMinus + adjPlus - adp;

    return fAmt.toFixed(2);
  };

  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";

    let wt;
    try {
      wt = JSON.parse(obj.workingHrs);
    } catch (e) {
      return "";
    }

    if (!Array.isArray(wt) || wt.length === 0) return "";

    const sortWt = [...wt].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const first = sortWt[0];
    const last = sortWt[sortWt.length - 1];

    const lastDate =
      last.type === "m"
        ? getMonthLastDay(last.start)
        : last.start;

    return (
      <div>
        <Moment format="MM/DD/YYYY">{first.start}</Moment>
        {" - "}
        <Moment format="MM/DD/YYYY">{lastDate}</Moment>
      </div>
    );
  };

  const getInvoiceDeduction = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) =>
        x.timeLogId === item.id
        && x.adpDeduction !== null
    );
    if (tmLogs.length === 0) {
      return "";
    }
    return <>
      {tmLogs.map((inv) => (
        <React.Fragment>
          {inv.adpDeduction}
          <br />
          {inv?.adpDocList?.map(
            (doc) => (
              <button
                className="btn btn-sm btn-link p-0"
                onClick={() =>
                  handleDownloadFile(
                    doc.invDoc
                  )
                }
              >
                {doc.documentName}
              </button>
            )
          )}
          {inv?.adpDocList?.length > 0 && <br />}
          <Moment format="MMM Do YYYY, h:mm a">
            {inv.adpDateTime}
          </Moment>
        </React.Fragment>
      ))}
    </>
  }

  const getGeneratedInvoice = (item) => {
    const tmStatus = timeLogInvoices.filter((x) =>
      x.timeLogId === item.id && x.status !== null);

    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.invDoc !== null);
    if (tmLogs.length === 0) {
      return <button
        className="btn btn-sm btn-link p-0"
        onClick={() =>
          handleInvShowHide(item)
        }
        disabled={tmStatus[0]?.status === false}
      >
        Upload / Generate
      </button>
    }

    return <>
      {tmLogs.map((inv) => (
        <React.Fragment>
          {inv.invoiceNumber}

          <br />
          <button
            className="btn btn-sm btn-link p-0"
            onClick={() => handleDownloadFile(inv.invDoc)}
          >
            {inv.invDoc.documentName}
          </button>
          <br />
          {!tmStatus[0]?.status && (inv.notes === "delete" ? "Request Sent to Delete" : <button
            type="button"
            className="btn btn-sm p-0"
            title="Delete Request Invoice Document"
            //disabled={isLocked}
            onClick={() => handleDeleteInvoiceDoc(inv.id)}
          >
            <i className="fa fa-trash text-dark" /> Send Request to Delete
          </button>)}

        </React.Fragment>
      ))}
    </>
  }

  const handleDeleteInvoiceDoc = async (id) => {
    const result = await getConfirmAlert("", "Are you sure you want to send request to delete this document?", "error");
    if (result.isConfirmed) {
      dispatch(timeLogInvDocDeleteReq(id))
    }
  }

  useEffect(() => {
    if (timeLogDeleteReqStatusSelector) {
      getAlert("", "Request Sent Successfully.", "success");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogInvoice(candidateObj.performerid));
    }
  }, [timeLogDeleteReqStatusSelector])

  const getInvoiceStatus = (item) => {
    const tmLogs = timeLogInvoices.filter((x) =>
      x.timeLogId === item.id && x.status !== null);

    if (tmLogs.length > 0) {
      return <>
        {tmLogs.map((inv) => (
          <React.Fragment>
            {inv.status === true && (
              <span>
                Approved
              </span>
            )}
            {inv.status === false && (
              <span>
                Rejected
              </span>
            )}
            <br />
            <Moment format="MMM Do YYYY">
              {inv.reviewDateTime}
            </Moment>
          </React.Fragment>
        ))}
      </>
    }

    return "";
  }

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id &&
        x.paymentMode !== null
    );

    if (tmLogs.length > 0) {
      return <>
        {tmLogs.map(pay =>

          <React.Fragment>
            <button
              className="btn btn-sm btn-link p-0"
              onClick={() => handlePayShowHide(pay)}
            >
              Paid By IPCS
            </button>
            <br />

            <Moment format="MMM Do YYYY">
              {pay.payDateTime}
            </Moment>
            <br />
            Paid : {pay.paidAmount}
            {pay.docList?.length > 0 && <br />}
            {pay.docList?.map((doc) => (
              <button
                className="btn btn-sm btn-link p-0"
                onClick={() => handleDownloadFile(doc)}
              >
                {doc.documentName}
              </button>
            ))}

          </React.Fragment>
        )}
      </>
    }
    return "";
  }

  const getDueAmountStatus = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id &&
          x.paidAmount !== null
      );
    if (tmLogs.length === 0) return "";

    return <>
      {tmLogs.map((inv) => parseFloat(getFinalAmout(item) - inv.paidAmount).toFixed(2))}
    </>

  }

  const handlePayShowHide = (obj) => {
    setPayShowHide(!payShowHide);
    setTimeLogObj(obj);
  };

  const handleInvShowHide = (obj) => {
    if (obj === "save") {
      if (selectedItem?.performerid) {
        dispatch(loadTimeLogs(selectedItem.performerid));
        dispatch(loadTimeLogInvoice(selectedItem.performerid));
      }
      setInvShowHide(false);
      setTimeLogObj(null);
    }
    else {
      setInvShowHide(!invShowHide);
      setTimeLogObj(obj);
    }

  };

  const handleShowHide = (obj) => {
    setShowHide(!showHide);
    setTimeLogObj(obj);
  };

  const handleNotesComments = (type, obj) => {
    if (type === "save") {
      setTimeLogObj(null);
      setNoteShowHide(false);
    } else {
      setTimeLogObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };


  let item = "";
  if (selectedItem)
    item = selectedItem;

  return (
    <React.Fragment>

      <div className="col-md-12 text-right">
        <button
          className="btn btn-sm btn-outline-default btn-min-width mb-2 mt-2"
          onClick={() => navigate(-1)}
        >
          <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div className="col-md-12 form-group">
        <div className="table-responsive">
          <table className="table align-items-center table-flush table-hover table-striped mb-2 border">
            <thead className="thead-light">
              <tr>
                <th>Candidate #<br />IPCS ID</th>
                <th>Candidate Details</th>
                <th>Agency / Client</th>
                <th>Duration</th>
                <th>Onboarding Status</th>
              </tr>
            </thead>
            <tbody>
              {item !== "" &&
                <tr>
                  <td>
                    {item.performerid}
                    <br />
                    {item.maxloans}
                  </td>
                  <td>
                    <span className="text-uppercase font-weight-bold">
                      {item.performername} {item.lastName}
                    </span>
                    <br />
                    <a href="#">{item.performeremail}</a>
                    <br />
                    {item.contactNo && getFormatedNumber(item.contactNo)}
                    <br />
                    {getFieldData(
                      item.performerData,
                      "projectengagement",
                      "PositionTitle"
                    )}
                  </td>
                  <td>
                    {
                      getFieldData(
                        item.performerData,
                        "projectengagement",
                        "AgencyName"
                      ) ?
                        getFieldData(
                          item.performerData,
                          "projectengagement",
                          "AgencyName"
                        ) :

                        "NA"
                    }
                    {/* {getFieldData(
                      item.performerData,
                      "projectengagement",
                      "AgencyName"
                    )} */}
                  </td>
                  <td>
                    {item?.duration?.duration ? (
                      <React.Fragment>
                        {item.duration.duration} Months
                        <br />
                        Start :{" "}
                        <Moment format="MMM Do YYYY">
                          {item.duration.startDate}
                        </Moment>
                        <br />
                        End :{" "}
                        <Moment format="MMM Do YYYY">
                          {item.duration.endDate}
                        </Moment>
                      </React.Fragment>
                    ) : "NA"}
                  </td>
                  <td>
                    {item.appSubmit && (
                      <span>
                        Complete
                      </span>
                    )}
                    {!item.appSubmit && (
                      <span>
                        Pending
                      </span>
                    )}
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-md-12">
        <div className="card shadow-none border">
          <div className="card-header p-3">
            <i className="fa fa-square wf-phase6-box mr-2" aria-hidden="true"></i>
            <span className="h3">
              Invoice Detail
            </span>

          </div>
          <div className="card-body p-3">
            <div className="row">
              <div className="col-md-6 form-group">
                <label
                  htmlFor="filterYear"
                  className="form-control-label"
                >
                  Invoice Year
                </label>
                <select
                  name="filterYear"
                  id="year"
                  className="form-control"
                  value={filterYear}
                  onChange={({ currentTarget }) => setFilterYear(currentTarget.value)}
                >
                  <option value="">Year</option>
                  {years.map((y) => (
                    <option value={y.name}>{y.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 form-group">
                <label
                  htmlFor="filterMonth"
                  className="form-control-label"
                >
                  Invoice Month
                </label>
                <select
                  name="filterMonth"
                  id="month"
                  className="form-control"
                  value={filterMonth}
                  onChange={({ currentTarget }) => setFilterMonth(currentTarget.value)}
                >
                  <option value="">Month</option>
                  {months.map((m) => (
                    <option value={m.id}>{m.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table align-items-center table-flush table-striped mb-2 border">
                    <thead className="thead-light">
                      <tr>
                        <th>Year</th>
                        <th>Month</th>
                        <th>Period
                          <br />
                          Time Logged</th>
                        <th>Hrs<br />Days</th>
                        <th>Rate/Hr ($)</th>
                        <th>Invoice<br />Amount ($)
                        </th>
                        {w9Type === "W2 Hourly with Benefits" && (
                          <th>Cost of benefit ($)</th>
                        )}
                        {entType === "W2 Basis" && usrType !== "recruiter" && (
                          <th>ADP Deduction ($)</th>
                        )}
                        <th>Invoice</th>
                        <th>IPCS Review</th>
                        <th>Final Pay<br />Amount ($)</th>
                        <th>Payment<br />Amount ($)</th>
                        {/* <th>Due Amount ($)</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {timeLogs.map((item) => (
                        <tr>
                          <td>{item.year}</td>
                          <td>{getMonthName(item.month)}</td>
                          <td>
                            {getMonthlyPeriod(item)}
                            <button
                              className="btn btn-sm btn-link p-0"
                              onClick={() => handleShowHide(item)}
                            >
                              View
                            </button>
                            <br />
                            {item.docList?.map((doc) => (
                              <li className="list-group-item p-0">
                                <button
                                  className="btn btn-sm btn-link"
                                  onClick={() => handleDownloadFile(doc)}
                                >
                                  {doc.documentName.length > 15
                                    ? doc.documentName.substring(0, 15) + "..."
                                    : doc.documentName}
                                </button>

                              </li>
                            ))}
                          </td>

                          <td>
                            <i className="fa fa-clock-o" /> {formatTotalHours(item?.workingHrs)}
                            <br />
                            {getTotalDays(item.workingHrs) + " Days"}
                          </td>
                          <td>
                            {(() => {
                              const { rate, effectiveDate } = getApplicableRateDetails(item);
                              return (
                                <>
                                  {rate}
                                  <br />
                                  {effectiveDate && (
                                    <Moment format="MM/DD/YYYY">
                                      {effectiveDate}
                                    </Moment>
                                  )}
                                </>
                              );
                            })()}
                          </td>
                          <td>
                            {getInvoiceAmount(item)}
                          </td>
                          {w9Type === "W2 Hourly with Benefits" && (
                            <td>{costBefenifit}</td>
                          )}
                          {entType === "W2 Basis" && usrType !== "recruiter" && (
                            <td>
                              {getInvoiceDeduction(item)}
                            </td>
                          )}
                          {(entType === "C2C Basis" || usrType === "recruiter") && (
                            <td>
                              {getGeneratedInvoice(item)}
                            </td>
                          )}

                          <td>
                            <button
                              className="btn btn-sm btn-link p-0"
                              onClick={() => handleNotesComments("", item)}
                            >
                              View <span className="badge badge-pill badge-success mt--1 text-dark">{item?.allComments.filter(x => x.commentType === notesType).length}</span>
                            </button>
                          </td>
                          <td>
                            {getFinalAmout(item)}
                            <br />
                            {getInvoiceStatus(item)}
                          </td>
                          <td>
                            {getPaymentStatus(item)}
                          </td>
                          {/* <td>
                            {getDueAmountStatus(item)}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        candidateObj={item}
        selectedObj={timeLogObj}
        timeLogsData={timeLogs}
      ></CandidatePay>

      <AddNewTimeLog
        showHide={showHide}
        handleShowHide={handleShowHide}
        selectedObj={timeLogObj}
        candidateObj={item}
        viewType="invoice"
        allTimeLogs={timeLogs}
        projectStartDate={projectStDt}
      ></AddNewTimeLog>

      <UploadInvoice
        invShowHide={invShowHide}
        handleInvShowHide={handleInvShowHide}
        candidateObj={item}
        selectedObj={timeLogObj}
        timeLogInvoices={timeLogInvoices}
        allRates={allRates}
        entType={entType}
      ></UploadInvoice>
      {noteShowHide &&
        <AddEditNotes
          noteShowHide={noteShowHide}
          handleNoteShowHide={handleNotesComments}
          notesType={notesType}
          candidateObj={item}
          timeLogObj={timeLogObj}
        ></AddEditNotes>}
    </React.Fragment>
  );
}
